import { createContext, useMemo, useContext } from 'react';
import { jsx } from 'react/jsx-runtime';

const metaContext = /*#__PURE__*/createContext({
  stage: 'dev',
  version: 'local',
  appType: 'home'
});
function MetaProvider({
  children,
  version,
  stage,
  appType
}) {
  const meta = useMemo(() => {
    return {
      version,
      stage,
      appType
    };
  }, [version, stage, appType]);
  return /*#__PURE__*/jsx(metaContext.Provider, {
    value: meta,
    children: children
  });
}

function useMeta() {
  return useContext(metaContext);
}

export { MetaProvider, metaContext, useMeta };
//# sourceMappingURL=index.js.map
